import MermaidRenderer from './mermaid-renderer'
import {MermaidViewer} from './mermaid-viewer'
import type {MermaidEventTypes} from './mermaid-viewer'

class FileMissingError extends Error {}

class MermaidFileViewer extends MermaidViewer<ContainerResizeEvent> {
  private data: string

  constructor(eventTypes: MermaidEventTypes) {
    super(eventTypes)
    this.data = ''
  }

  async #loadData(file: string) {
    this.iframeMessenger.load(file, {
      json: false,
      success: (data: unknown) => {
        this.data = data as string
        this.iframeMessenger.set(this.loadEvent)
      },
      error: (error: unknown) => {
        this.reportError(error as Error)
      },
    })
  }

  initialize() {
    const file = this.el.getAttribute('data-file')

    if (!file) {
      const fileMissingError = new FileMissingError('No file to load')
      this.reportError(fileMissingError)
      throw fileMissingError
    }

    this.#loadData(file)
  }

  onLoad(event: ContainerResizeEvent, renderer?: MermaidRenderer) {
    const {width} = event.detail

    if (!(renderer instanceof MermaidRenderer)) {
      renderer = new MermaidRenderer({data: this.data, el: this.el, width})
      window.addEventListener('resize', this.lazyRender(renderer))
    } else {
      renderer.width = width
    }

    return renderer
  }
}

export {MermaidFileViewer, FileMissingError}
